<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Dental Billing </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Add Dental Billing</a></li>
                                
                            </ol>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <!-- Search and export area -->
                    <div class="card">
                        <div class="card-header">
                            <h3 style="text-align: left;">New Billing</h3>
                        </div>

                        <div class="card-body">   
                            <form v-if="!loading">
                                <!-- Bill Information -->
                                <div class="row mb-1">
                                    <div class="col-md-12">
                                        <h4 class="wpr_general_sign_title">Invoice, Patient information and Other's </h4>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="bill_no" style="width: 100%; height: 34px; padding: 10px;">Invoice No <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="text" class="form-control border" v-model="form.bill_no" placeholder="Enter Bill No"  @keypress="onkeyPress('bill_no')">
                                                        <div class="invalid-feedback" v-if="errors.bill_no">
                                                            {{errors.bill_no[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="bill_date" style="width: 100%; height: 34px; padding: 10px;">Invoice Date  <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="date" class="form-control border" v-model="form.bill_date" placeholder="Enter Date" @keypress="onkeyPress('bill_date')">
                                                        <div class="invalid-feedback" v-if="errors.bill_date">
                                                            {{errors.bill_date[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>  

                                        <div class="row">
                                            <div class="col-md-6 mb-1">
                                                <div class="row">

                                                    <div class="col-md-12 mb-1">
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <label for="service_id" style="width: 100%; height: 34px; padding: 10px;">Services <span style="color: red">*</span></label>
                                                            </div>
                                                            <div class="col-md-8">
                                                                <Multiselect 
                                                                    class="form-control border" 
                                                                    mode="single"
                                                                    v-model="form.service_id"
                                                                    placeholder="Select Service"  
                                                                    :searchable="true" 
                                                                    :filter-results="true"
                                                                    :options="service_options"
                                                                    :classes="multiclasses"
                                                                    :close-on-select="true" 
                                                                    :min-chars="1"
                                                                    :resolve-on-load="false"
                                                                    :create-option="true"
                                                                    @change="loadServiceDaysConfig($event)"
                                                                    @input="onkeyPress('service_id')"
                                                                    v-if="renderOptionComponent"
                                                                />
                                                                <div class="invalid-feedback" v-if="errors.service_id">
                                                                    {{errors.service_id[0]}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-12 mb-1">
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <label for="service_days" style="width: 100%; height: 34px; padding: 10px;">Service Day <span style="color: red">*</span></label>
                                                            </div>
                                                            <div class="col-md-8">
                                                                <select
                                                                    id="service_days"
                                                                    class="form-control border"
                                                                    v-model="form.day_number"
                                                                    @change="applyServiceDaysConfig($event.target.value)"
                                                                    @input="onkeyPress('day_number')"
                                                                    :disabled="!form.service_id"
                                                                >
                                                                    <option value="">Select Service Day</option>

                                                                    <!-- If configuration provides options use them -->
                                                                    <template v-if="service_days_options && service_days_options.length > 0">
                                                                        <option v-for="opt in service_days_options" :key="opt.value" :value="opt.value">
                                                                            {{ opt.label }}
                                                                        </option>
                                                                    </template>
                                                                </select>

                                                                <small v-if="!form.service_id" class="text-muted">Select a service first to load configured service days.</small>

                                                                <div class="invalid-feedback" v-if="errors.service_day">
                                                                    {{ errors.service_day[0] }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-12 mb-1">
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <label for="doctor_id" style="width: 100%; height: 34px; padding: 10px;">Doctor <span style="color: red">*</span></label>
                                                            </div>
                                                            <div class="col-md-8">
                                                                <div class="input-group input-group-merge">  
                                                                    <Multiselect 
                                                                        class="form-control border" 
                                                                        mode="single"
                                                                        v-model="form.doctor_id"
                                                                        placeholder="Select Doctor"  
                                                                        :searchable="true" 
                                                                        :filter-results="true"
                                                                        :options="doctor_options"
                                                                        :classes="multiclasses"
                                                                        :close-on-select="true" 
                                                                        :min-chars="1"
                                                                        :resolve-on-load="false"
                                                                        :create-option="true"
                                                                        v-if="renderOptionComponent"
                                                                    />
                                                                    <div class="input-group-text">
                                                                        <a @click="doctorAddModal()">
                                                                            <i class="fas fa-plus-circle"></i>
                                                                        </a>
                                                                    </div>
                                                                </div>                                                   
                                                                <div class="invalid-feedback" v-if="errors.doctor_id">
                                                                    {{errors.doctor_id[0]}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    
                                                    <div class="col-md-12 mb-1">
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <label for="patient_name" style="width: 100%; height: 34px; padding: 10px;">Patient Name  <span style="color: red">*</span></label>
                                                            </div>
                                                            <div class="col-md-8">
                                                                <template v-if="patients.length > 0">
                                                                    <Multiselect 
                                                                        class="form-control border" 
                                                                        mode="single"
                                                                        v-model="search_patient_id"
                                                                        placeholder="Select Patient"  
                                                                        :searchable="true" 
                                                                        :filter-results="true"
                                                                        :options="patient_options"
                                                                        :classes="multiclasses"
                                                                        :close-on-select="true" 
                                                                        :min-chars="1"
                                                                        :resolve-on-load="false" 
                                                                        :create-option="true" 
                                                                        ref="patientMultiselect"
                                                                        @change="changePatient($event)"
                                                                        v-if="renderOptionComponent"
                                                                    />
                                                                </template>
                                                                <template v-else>
                                                                    <input type="text" class="form-control border" v-model="form.patient_name" placeholder="Enter Patient Name" @keypress="onkeyPress('patient_name')">
                                                                </template>
                                                                <div class="invalid-feedback" v-if="errors.patient_name">
                                                                    {{errors.patient_name[0]}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-12 mb-1">
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <label for="patient_phone" style="width: 100%; height: 34px; padding: 10px;">Patient Phone <span style="color: red">*</span></label>
                                                            </div>
                                                            <div class="col-md-8">
                                                                <input
                                                                    type="text"
                                                                    class="form-control border"
                                                                    v-model="form.patient_phone"
                                                                    placeholder="Enter Patient Phone"
                                                                    @keypress="onkeyPress('patient_phone')"
                                                                    @input="form.patient_phone = form.patient_phone.replace(/[^0-9]/g, '').slice(0, 11)"
                                                                    @keyup="getPatientByPhone($event)"
                                                                >
                                                                <div class="invalid-feedback" v-if="errors.patient_phone">
                                                                    {{errors.patient_phone[0]}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="col-md-12 mb-1">
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <label for="patient_age" style="width: 100%; height: 34px; padding: 10px;">Patient Age <span style="color: red"></span></label>
                                                            </div>
                                                            <div class="col-md-8">
                                                                <div class="d-flex gap-2">
                                                                    <input type="number"
                                                                        class="form-control"
                                                                        placeholder="Years"
                                                                        min="0"
                                                                        v-model.number="age.years"
                                                                        @input="validateAge('years'), updateAge()">

                                                                    <input type="number"
                                                                        class="form-control"
                                                                        placeholder="Months"
                                                                        min="0"
                                                                        max="11"
                                                                        v-model.number="age.months"
                                                                        @input="validateAge('months'), updateAge()">

                                                                    <input type="number"
                                                                        class="form-control"
                                                                        placeholder="Days"
                                                                        min="0"
                                                                        max="30"
                                                                        v-model.number="age.days"
                                                                        @input="validateAge('days'), updateAge()">
                                                                </div>

                                                                <!-- Hidden / Readonly Final Value -->
                                                                <input type="hidden" v-model="form.patient_age">
                                                                <!-- <input type="number" class="form-control border" v-model="form.patient_age" placeholder="Enter Patient Age" @keypress="onkeyPress('patient_age')"> -->

                                                                <small class="text-muted">
                                                                    {{ form.patient_age ?? '' }}
                                                                </small>
                                                                <div class="invalid-feedback" v-if="errors.patient_age">
                                                                    {{errors.patient_age[0]}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="col-md-12 mb-1">
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <label for="patient_gender" style="width: 100%; height: 34px; padding: 10px;">Gender <span style="color: red"></span></label>
                                                            </div>
                                                            <div class="col-md-8">
                                                                <Multiselect 
                                                                    class="form-control border" 
                                                                    mode="single"
                                                                    v-model="form.patient_gender"
                                                                    placeholder="Gender"  
                                                                    :searchable="true" 
                                                                    :filter-results="true"
                                                                    :options="gender_options"
                                                                    :classes="multiclasses"
                                                                    :close-on-select="true" 
                                                                    :min-chars="1"
                                                                    :resolve-on-load="false" 
                                                                    :create-option="false"
                                                                    @change="onkeyPress('patient_gender')"
                                                                    v-if="renderOptionComponent"
                                                                />  
                                                                <div class="invalid-feedback" v-if="errors.patient_gender">
                                                                    {{errors.patient_gender[0]}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        
                                    </div>
                                </div>

                                <hr>

                                <div class="row mb-3">
                                    <div class="col-md-3">
                                        <label for="contract_id">Patient Contract </label> <br>
                                        <Multiselect 
                                            class="form-control border" 
                                            mode="single"
                                            v-model="form.contract_id"
                                            placeholder="Select Patient Contract"  
                                            :searchable="true" 
                                            :filter-results="true"
                                            :options="contract_options"
                                            :classes="multiclasses"
                                            :close-on-select="true" 
                                            :min-chars="1"
                                            :resolve-on-load="false" 
                                            :create-option="true" 
                                            @change="onContractChange($event)"
                                            v-if="renderOptionComponent"
                                        />
                                    </div>

                                    <div class="col-md-9">
                                        <div class="row">
                                            <div :class="[form.contract_id ? 'col-md-6' : 'col-md-4']">
                                                <div class="row">
                                                    <div :class="[form.contract_id ? 'col-md-4' : 'col-md-12']">
                                                        <label for="contract_amount">Contract Amount</label>
                                                        <input type="text" class="form-control border" v-model="form.contract_amount" id="contract_amount" placeholder="Contract Amount">
                                                        <div class="invalid-feedback" v-if="errors.contract_amount">
                                                            {{errors.contract_amount[0]}}
                                                        </div>  
                                                    </div>
                                                    
                                                    <div class="col-md-4" v-if="form.contract_id">
                                                        <label for="contract_paid_amount">Contract Paid</label>
                                                        <input type="text" class="form-control border" v-model="form.contract_paid_amount" id="contract_paid_amount" placeholder="Contract Paid Amount" readonly>
                                                        <div class="invalid-feedback" v-if="errors.contract_paid_amount">
                                                            {{errors.contract_paid_amount[0]}}
                                                        </div>  
                                                    </div>

                                                    <div class="col-md-4" v-if="form.contract_id">
                                                        <label for="contract_due_amount">Contract Due</label>
                                                        <input type="text" class="form-control border" v-model="form.contract_due_amount" id="contract_due_amount" placeholder="Contract Due Amount" readonly>
                                                        <div class="invalid-feedback" v-if="errors.contract_due_amount">
                                                            {{errors.contract_due_amount[0]}}
                                                        </div>  
                                                    </div>
                                                </div>
                                            </div>

                                            <div :class="[form.contract_id ? 'col-md-3' : 'col-md-4']">
                                                <label for="service_amount">Service Amount</label>
                                                <input type="text" class="form-control border" v-model="form.service_amount" id="service_amount" placeholder="Service Amount">
                                                <div class="invalid-feedback" v-if="errors.service_amount">
                                                    {{errors.service_amount[0]}}
                                                </div>
                                            </div>

                                            <div :class="[form.contract_id ? 'col-md-3' : 'col-md-4']">
                                                <label for="visit_amount">Doctor Visit Fee</label>
                                                <input type="text" class="form-control border" v-model="form.visit_amount" id="visit_amount" placeholder="Doctor Visit Fee">
                                                <div class="invalid-feedback" v-if="errors.visit_amount">
                                                    {{errors.visit_amount[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr>

                                <!-- Payment and Discount  -->
                                <div class="row mb-3">
                                    <div class="col-md-8" style="border-right: 1px solid #e0e0e0;">
                                        <!-- Dental Service Items Information -->
                                        <div class="item_area" style="padding: 10px; border: 1px solid #e0e0e0;">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <h4 class="wpr_general_sign_title">Service Items</h4>
                                                </div>
                                            </div>

                                            <div class="row mb-2" v-if="service_stock_items.length > 0 && form.day_number">
                                                <div class="col-md-8">
                                                    <Multiselect 
                                                        class="form-control border" 
                                                        mode="single"
                                                        v-model="selected_service_stock_item"
                                                        placeholder="Select Service Item"  
                                                        :searchable="true" 
                                                        :filter-results="true"
                                                        :options="stock_item_options"
                                                        :classes="multiclasses"
                                                        :close-on-select="true" 
                                                        :min-chars="1"
                                                        :resolve-on-load="false" 
                                                        :create-option="true" 
                                                        v-if="renderOptionComponent"
                                                    />
                                                </div>
                                                <div class="col-md-4" style="text-align: right;">
                                                    <button type="button" class="btn btn-sm btn-primary" @click="addServiceDayItems()">
                                                        <i class="fas fa-plus-circle"></i> Add Service Items
                                                    </button>
                                                </div>

                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="table-responsive" style="padding: 0;">
                                                        <table class="table table-bordered table-centered mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th width="5%">SL</th>
                                                                    <th width="35%">Item</th>
                                                                    <th width="10%">Qty</th>
                                                                    <th width="10%">Rate</th>
                                                                    <th width="10%">Total</th>
                                                                    <th width="5%">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, index) in form.service_day_items" :key="index">
                                                                    <td>{{ index +1 }}</td>
                                                                    <td>{{ item.product_name }}</td>                                                    
                                                                    <td>
                                                                        <input type="number" class="form-control" v-model="item.service_qty" @input="updateConsumeQty(index)">
                                                                    </td>
                                                                    <td>{{ item.per_service_cost }}</td>
                                                                    <td class="text-right">{{ (item.per_service_cost * item.service_qty) }}</td>
                                                                    <td>
                                                                        <button type="button" class="btn btn-danger btn-sm" @click="removeServiceDayItems(index)">
                                                                            <i class="fas fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <th colspan="4" class="text-right">Total</th>
                                                                    <th class="text-right">
                                                                        {{ Number(totalServiceItemsValue)
                                                                            .toLocaleString(undefined, {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            }) 
                                                                        }}
                                                                    </th>
                                                                </tr>
                                                            </tfoot>

                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="payment_amount_area">
                                            <table class="table-sm table table-bordered border" style="margin-bottom: 15px">
                                                <thead class="tableFloatingHeaderOriginal">
                                                    <tr class="border item-head">
                                                        <th>Total</th>
                                                        <th style="text-align: right;">
                                                            {{  Number(totalCalculateAmount)
                                                                .toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) 
                                                            }}
                                                        </th> 
                                                    </tr>
                                                    <tr class="item-head">
                                                        <th>Discount </th>
                                                        <th style="text-align: right;">
                                                            <input type="number" step="any" scrolling="no" v-model="form.discount" class="form-control" style="text-align:right;">
                                                        </th>
                                                    </tr>
                                                    
                                                    <tr class="item-head">
                                                        <th>Payable Amount</th>
                                                        <th style="text-align: right;">
                                                            {{ Number(netAmountCalculate)
                                                                .toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) 
                                                            }}
                                                        </th>
                                                    </tr>
                                                    
                                                    <tr class="item-head">
                                                        <th>Received Amount</th>
                                                        <th style="text-align: right;">
                                                            <input type="number" step="any" scrolling="no" v-model="form.received_amount" class="form-control" style="text-align: right;">
                                                        </th>
                                                    </tr>
                        
                                                    <tr class="item-head">
                                                        <th>Due Amount</th>
                                                        <th style="text-align: right;">
                                                            {{ (netAmountCalculate > form.received_amount) 
                                                                ? Number(netAmountCalculate - form.received_amount)
                                                                    .toLocaleString(undefined, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) 
                                                                : Number(0)
                                                                    .toLocaleString(undefined, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) 
                                                            }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </table>

                                        </div>
                                    </div>
                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-md-5"></div>
                                    <div class="col-md-4"></div>
                                    <div class="form-group col-md-4" style="text-align: right; display: none;">
                                        <!-- <label for="cost_center_id">Cost Center </label><br> -->
                                        <treeselect 
                                            v-model="form.cost_center_id"
                                            :multiple="false" 
                                            :always-open="false"
                                            :options="costCenterOptions"
                                            :value-consists-of="valueConsistsOf"
                                            :normalizer="normalizer"
                                            :default-expand-level="Infinity"
                                            :disable-branch-nodes="true"
                                            :search-nested="true"                                                
                                            placeholder='Select Cost Center'
                                            v-if="renderOptionComponent"
                                        />
                                        <div class="invalid-feedback" v-if="errors.cost_center_id">
                                            {{errors.cost_center_id[0]}}
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="action_btn" style="text-align: right;">
                                            <!-- <button type="button" class="btn btn-sm btn-danger" id="reset" @click="toggleModal()" style="margin-right: 10px;">
                                                RESET
                                            </button>

                                            <button type="button" class="btn btn-sm btn-warning" id="clear-cart-item" @click="clearAllCartItems" style="margin-right: 10px;">
                                                Clear Item
                                            </button> -->

                                            <button type="button" class="btn btn-sm btn-info" id="invoice-preview" @click="invoicePreviewModal" style="margin-right: 10px;">
                                                Invoice Preview
                                            </button> 

                                            <button type="button" class="btn btn-sm btn-primary " :disabled="disabled" @click.prevent="submitForm()">
                                                <span v-show="isSubmit">
                                                    <i class="fas fa-spinner fa-spin" ></i>
                                                </span> SUBMIT
                                            </button> 
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 

            <!-- Doctor Add Modal -->
            <Modal @close="toggleDoctorModal()" :modalActive="doctorAddModalActive">
                <div class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <h3>Doctor Create</h3>
                        <button @click="toggleDoctorModal()" type="button" class="btn btn-default">X</button>
                    </div>
                    <form @submit.prevent="submitDoctorForm()" enctype="multipart/form-data" >
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row  ">
                                        <!-- <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="doctor_code">Doctor Code *</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('doctor_code')" v-model="dform.doctor_code" id="doctor_code" placeholder="Doctor Code" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.doctor_code">
                                                    {{errors.doctor_code[0]}}
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="form-group col-md-6">
                                            <div class="mb-3">
                                                <label for="company_id">Company *</label> 
                                                <select class="form-control border" v-model="dform.company_id" @change="onkeyPress('company_id')" id="company_id">
                                                    <option value="0">Select company</option>
                                                    <option v-for="(company, index) in companies" :value="company.id" :key="index">
                                                        {{company.name}}
                                                    </option>
                                                </select> 
                                                <div class="invalid-feedback" v-if="errors.company_id">
                                                    {{errors.company_id[0]}}
                                                </div>
                                            </div>
                                        </div> 

                                        <div class="form-group col-md-6">
                                            <label for="department_id" style="float: none;">Doctor Department *</label> 
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="dform.department_id"
                                                placeholder="Select Department"  
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="departments"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                            />   
                                            <div class="invalid-feedback" v-if="errors.department_id">
                                                {{errors.department_id[0]}}
                                            </div>
                                        </div> 
                                    </div>

                                    <div class="row ">
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="first_name">First Name *</label>
                                                <input type="text" class="form-control border"  @keypress="onkeyPress('first_name')" @keyup="ledgerAccountNameSetup($event.target.value)" v-model="dform.first_name" id="first_name" placeholder="First Name" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.first_name">
                                                    {{errors.first_name[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="last_name">Last Name *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('last_name')" v-model="dform.last_name" id="last_name" placeholder="Last Name" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.last_name">
                                                    {{errors.last_name[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="email">Email *</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('email')" v-model="dform.email" id="email" placeholder="Doctor Email" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.email">
                                                    {{errors.email[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="phone">Phone *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('phone')" v-model="dform.phone" id="phone" placeholder="Doctor mobile number"> 
                                                <div class="invalid-feedback" v-if="errors.phone">
                                                    {{errors.phone[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="designation">Designation *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('designation')" v-model="dform.designation" id="designation" placeholder="Designation"> 
                                                <div class="invalid-feedback" v-if="errors.designation">
                                                    {{errors.designation[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="qualification">Qualification *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('qualification')" v-model="dform.qualification" id="qualification" placeholder="Qualification"> 
                                                <div class="invalid-feedback" v-if="errors.qualification">
                                                    {{errors.qualification[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <div class="mb-3">
                                                    <label for="specialist">Specialist *</label>
                                                    <input type="text" class="form-control border" @keypress="onkeyPress('specialist')" v-model="dform.specialist" id="specialist" placeholder="Specialist"> 
                                                    <div class="invalid-feedback" v-if="errors.specialist">
                                                        {{errors.specialist[0]}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="row">
                                                <div class="form-group col-md-4">
                                                    <div class="mb-3">
                                                        <label for="dob">Date of Birth </label>
                                                        <input type="date" class="form-control border " @keypress="onkeyPress('dob')" v-model="dform.dob" id="dob" placeholder="" autocomplete="off"> 
                                                        <div class="invalid-feedback" v-if="errors.dob">
                                                            {{errors.dob[0]}}
                                                        </div>
                                                    </div>
                                                </div> 

                                                <div class="form-group col-md-4">
                                                    <div class="mb-3">
                                                        <label for="blood_group">Blood Group </label> 
                                                        <select class="form-control border" v-model="dform.blood_group" @change="onkeyPress('blood_group')" id="blood_group">
                                                            <option value="null" selected>Select Blood Group</option>
                                                            <option value="A+">A+</option>
                                                            <option value="A-">A-</option>
                                                            <option value="AB+">AB+</option>
                                                            <option value="AB-">AB-</option>
                                                            <option value="B+">B+</option>
                                                            <option value="B-">B-</option>
                                                            <option value="O+">O+</option>
                                                            <option value="O-">O-</option>

                                                        </select> 
                                                        <div class="invalid-feedback" v-if="errors.blood_group">
                                                            {{errors.blood_group[0]}}
                                                        </div>
                                                    </div>
                                                </div> 

                                                
                                                <div class="form-group col-md-4">
                                                    <div class="mb-3">
                                                        <label for="gender">Gender *</label>
                                                        <select class="form-control border" v-model="dform.gender" @change="onkeyPress('gender')">
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                        </select>
                                                        <div class="invalid-feedback" v-if="errors.gender">
                                                            {{errors.gender[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <!-- <div class="row">
                                        <div class="form-group col-md-3">
                                            <div class="mb-3">
                                                <label for="status">Status *</label>
                                                <select class="form-control border" v-model="dform.status" @change="onkeyPress('status')">
                                                    <option value="1">Active</option>
                                                    <option value="0">Inactive</option>
                                                </select>
                                                <div class="invalid-feedback" v-if="errors.status">
                                                    {{errors.status[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="form-group col-md-3"> 
                                            <div class="mb-3" style="text-align: right;">
                                                <label for="create_user" style="width: 100%">&nbsp;&nbsp;</label>
                                                <input type="checkbox" class="form-check-input border " @change="onkeyPress('create_user')" true-value="1" false-value="0" v-model="dform.create_user" id="create_user"><b> Create User</b>
                                                <div class="invalid-feedback" v-if="errors.create_user">
                                                    {{errors.create_user[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-3" v-if="form.create_user == 1"> 
                                            <div class="mb-3">
                                                <label for="password">Password *</label>
                                                <input type="password" class="form-control border" @keypress="onkeyPress('password')" v-model="dform.password" id="password" placeholder="Password" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.password">
                                                    {{errors.password[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-3" v-if="form.create_user == 1"> 
                                            <div class="mb-3">
                                                <label for="password_confirmation">Confirm Password *</label>
                                                <input type="password" class="form-control border" @keypress="onkeyPress('password_confirmation')" v-model="dform.password_confirmation" id="password_confirmation" placeholder="Confirm Password" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.password_confirmation">
                                                    {{errors.password_confirmation[0]}}
                                                </div>
                                            </div>
                                        </div>                                    
                                    </div> -->

                                    <div class="row">
                                        <div class="form-group col-md-3">
                                            <div class="mb-3">
                                                <label for="commission_percentage">Commission Percent</label> 
                                                <input type="number" class="form-control" @keypress="onkeyPress('commission_percentage')" v-model="dform.commission_percentage" id="commission_percentage" placeholder="Commission Percent" autocomplete="off">
                                                <div class="invalid-feedback" v-if="errors.commission_percentage">
                                                    {{errors.commission_percentage[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6"> 
                                            <div class="mb-3">
                                                <label for="description">Description</label>
                                                <textarea class="form-control border" @keypress="onkeyPress('description')" v-model="dform.description" id="description" placeholder="Description" autocomplete="off"></textarea> 
                                                <div class="invalid-feedback" v-if="errors.description">
                                                    {{errors.description[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-3">
                                            <div class="form-group">
                                                <label style="width: 100%">Image (128X128)</label> <br>
                                                <div class="fileinput fileinput-new" data-provides="fileinput" style="position: relative;">
                                                <span class="btn btn-block btn-primary btn-file"><span class="fileinput-new"><i class="fa fa-camera"></i> Chose Image</span>
                                                <span class="fileinput-exists" style="display:none">Change Image</span><input type="file" name="..." @change="onImageChange"/></span>
                                                </div> 
                                                <div class="invalid-feedback" v-if="errors.dimage">
                                                    {{errors.dimage[0]}}
                                                </div>

                                                <img :src="imagePreview" v-if="dform.dimage" width="200" >
                                                <div v-if="editMode & !imagePreview">
                                                    <img :src="dform.dimage" v-if="dform.dimage" width="200">
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                  

                                    <div class="row">
                                        <div class="col-md-12">
                                            <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px; background-color: #313A46; padding: 5px 5px; color: #ffffff">Account Ledger Setup *</label>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="doctor_commission_account">Doctor Commission Account Ledger *</label>
                                            <input type="text" class="form-control border " @keypress="onkeyPress('doctor_commission_account')" v-model="dform.doctor_commission_account" id="doctor_commission_account" placeholder="Doctor Commission Account"> 
                                            <div class="invalid-feedback" v-if="errors.doctor_commission_account">
                                                {{errors.doctor_commission_account[0]}}
                                            </div>
                                        </div>
                                    </div>

                                </div> 
                            </div>
                        </div>
                        <div class="modal-footer"> 
                            <button type="button" class="btn btn-danger" @click="toggleDoctorModal()">
                                Close
                            </button> 
                            <button type="submit" class="btn btn-primary " :disabled="disabled">
                                <span v-show="isSubmit">
                                    <i class="fas fa-spinner fa-spin" ></i>
                                </span>{{btn}} 
                            </button> 
                        </div>
                    </form>
                </div>
            </Modal>           

            <!-- preview and Print Modal   -->
            <Modal @close="invoicePreviewModal()" :modalActive="invoicePreviewModalActive">
                <div class="modal-content scrollbar-width-thin invoice-modal">
                    <div class="modal-header">
                    <h5>Invoice</h5>
                    <button @click="invoicePreviewModal()" type="button" class="btn btn-default">
                        X
                    </button>
                    </div>
                    <div class="modal-body inv-perview">
                        <div id="invoice-billing" class="invoice-billing">
                            <div id="top">
                                <div class="row">
                                    <h2 class="text-center" style="font-size: 18px">{{this.retailShopName}}</h2>
                                    <h5 class="text-center" style="font-size: 14px"> {{ this.retailSmallText }}</h5>
                                    <p class="text-center cmb-5">
                                        {{ this.retailShopAddress }}
                                        <span v-if="invHeadPhone"> <br> Mobile: {{ this.invHeadPhone }} </span>
                                    </p> 
                                    <p class="text-center" ><strong> INVOICE </strong></p> 
                                </div>
                            </div>
                            <!--End InvoiceTop-->
                            <div id="mid">
                                <div class="info">
                                    <table style="width: 100%;">
                                        <tr>
                                            <td>ID No</td>
                                            <td>:</td>
                                            <td>{{ form.bill_no }}</td>
                                            <td>
                                                <BarcodeGenerator
                                                    :value="form.bill_no"
                                                    :format="'CODE128'"
                                                    :lineColor="'black'"
                                                    :height="22"
                                                    :width="1"
                                                    :elementTag="'img'"
                                                    :textPosition="19"
                                                    :fontSize="15"
                                                    :displayValue="false"
                                                    v-if="renderBarcodeComponent"
                                                />
                                            </td>
                                            <td style="text-align: right;">Date: {{ form.bill_date }}</td>
                                        </tr>
                                        <tr>
                                            <td>Name</td>
                                            <td>:</td>
                                            <td id="pname">{{ form.patient_name }}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Age</td>
                                            <td>:</td>
                                            <td>{{ form.patient_age }}</td>
                                            <td style="text-align: right;"><span>Gender: {{ form.patient_gender }}</span></td>
                                            <td style="text-align: right;"><span>M: {{ form.patient_phone }}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Doctor Name</td>
                                            <td>:</td>
                                            <td colspan="3">{{ (doctor_options.find(o => o.value === form.doctor_id) || {}).label || '' }}</td>
                                        </tr>
                                    </table>
                                </div>
                            
                            </div>
                            <!--End Invoice Mid-->
                            <div id="bot">
                                <div class="items-info">
                                    <table style="width: 100% !important;">
                                        <thead>
                                            <tr>
                                                <th>SL</th>
                                                <th>Service</th>
                                                <th>Day</th>
                                                <th style="text-align:right">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- Service (main) -->
                                            <tr v-if="form.service_id">
                                                <td>1</td>
                                                <td>{{ (service_options.find(o => o.value === form.service_id) || {}).label || 'Service' }}</td>
                                                <td>{{'Day-'+ form.day_number }}</td>
                                                <td style="text-align:right">
                                                    {{ Number(form.service_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                                </td>
                                            </tr>

                                            <!-- Doctor visit fee -->
                                            <tr v-if="form.visit_amount && Number(form.visit_amount) > 0">
                                                <td>{{ form.service_id ? 2 : 1 }}</td>
                                                <td>Doctor Visit Fee</td>
                                                <td></td>
                                                <td style="text-align:right">
                                                    {{ Number(form.visit_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!--End Table-->
                                </div>

                                <!-- Payment Info and Others-->
                                <div class="corporate-payment-info">
                                    <div class="row">
                                        <div class="col-md-7 col-xs-7">
                                            
                                        </div>
                                        <div class="col-md-5 col-xs-5">
                                            <table class="payment-info" style="width: 100%; text-align: right;">
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Total Amount</td>
                                                    <td>{{ totalCalculateAmount }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Discount </td>
                                                    <td>{{ this.form.discount }}</td>
                                                </tr>
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Payable </td>
                                                    <td>{{ Number(netAmountCalculate).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</td>
                                                </tr>                                                       
                                                <tr>
                                                    <td>Received Amount </td>
                                                    <td>{{ form.received_amount }}</td>
                                                </tr>                                                
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Due Amount </td>
                                                    <td>{{ netAmountCalculate - form.received_amount }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>                                            
                                </div>

                                <div class="fixed-div">
                                    <div class="status-signatures">
                                        <div class="row">
                                            <div class="col-md-8 col-xs-8">
                                                <div class="status-info">
                                                    <h3 v-if="(netAmountCalculate) == form.received_amount">
                                                        <span style="">PAID</span>
                                                    </h3> 
                                                    <h3 v-else>
                                                        <span>DUE</span>
                                                    </h3> 
                                                    <span style="font-size: 11px;">Printed on {{ new Date().toLocaleDateString() }} {{ new Date().toLocaleTimeString() }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-xs-4">
                                                <div class="signature-info">
                                                    <h4></h4>
                                                    <span>(Signature)</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="legal-info">
                                        <h6>
                                            সকল তথ্য ও সিরিয়াল এর জন্য হটলাইনঃ {{ this.invHeadPhone }}
                                        </h6>
                                    </div>
                                </div>

                            </div>
                            <!--End InvoiceBot-->
                        </div>
                        <!--End Invoice-->
                    </div>
                    <div class="modal-footer">
                        <div class="col-md-12">
                            <div class="row button-list pt-2">
                            <div class="col-md-4" style="padding: 0 5px">
                                <div class="d-grid">
                                <button
                                    type="button"
                                    class="btn btn-sm btn-success"
                                    @click="printInvoice('invoice-billing')"
                                >
                                    Print
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal> 
            <!-- Invoice Preview Modal End -->

            <!-- Invoice Print Modal After Save -->
            <Modal @close="invoiceModal()" :modalActive="invoiceModalActive">
                <div class="modal-content scrollbar-width-thin invoice-modal">
                    <div class="modal-header">
                    <h5>Invoice</h5>
                    <button @click="invoiceModal()" type="button" class="btn btn-default">
                        X
                    </button>
                    </div>
                    <div class="modal-body inv-perview">
                        <div id="billing-invoice" class="invoice-billing" v-if="billing_info != ''">
                            <div id="top">
                                <div class="row">
                                    <h2 class="text-center" style="font-size: 18px">{{this.retailShopName}}</h2>
                                    <h5 class="text-center" style="font-size: 14px"> {{ this.retailSmallText }}</h5>
                                    <p class="text-center cmb-5">
                                        {{ this.retailShopAddress }}
                                        <span v-if="invHeadPhone"> <br> Mobile: {{ this.invHeadPhone }} </span>
                                    </p> 
                                    <p class="text-center" ><strong> INVOICE </strong></p> 
                                </div>
                            </div>
                            <!--End InvoiceTop-->
                            <div id="mid">
                                <div class="info">
                                    <table style="width: 100%;">
                                        <tr>
                                            <td>ID No</td>
                                            <td>:</td>
                                            <td>{{ billing_info.bill_no }}</td>
                                            <td>
                                                <BarcodeGenerator
                                                    :value="billing_info.bill_no"
                                                    :format="'CODE128'"
                                                    :lineColor="'black'"
                                                    :height="22"
                                                    :width="1"
                                                    :elementTag="'img'"
                                                    :textPosition="19"
                                                    :fontSize="15"
                                                    :displayValue="false"
                                                    v-if="renderBarcodeComponent"
                                                />
                                            </td>
                                            <td style="text-align: right;">Date: {{ billing_info.bill_date }}</td>
                                        </tr>
                                        <tr>
                                            <td>Name</td>
                                            <td>:</td>
                                            <td id="pname">{{ billing_info.patient_name }}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Age</td>
                                            <td>:</td>
                                            <td>{{ billing_info.patient_age }}</td>
                                            <td style="text-align: right;"><span>Gender: {{ billing_info.patient_gender }}</span></td>
                                            <td style="text-align: right;"><span>M: {{ billing_info.patient_phone }}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Doctor Name</td>
                                            <td>:</td>
                                            <td colspan="3">{{ doctor_options.find(dop => dop.value == billing_info.doctor_id).label || '' }}</td>
                                        </tr>
                                    </table>
                                </div>
                            
                            </div>
                            <!--End Invoice Mid-->
                            <div id="bot">
                                <div class="items-info">
                                    <table style="width: 100% !important;">
                                        <thead>
                                            <tr>
                                                <th>SL</th>
                                                <th>Service</th>
                                                <th>Day</th>
                                                <th style="text-align:right">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- Service (main) -->
                                            <tr v-if="billing_info.service_id">
                                                <td>1</td>
                                                <td>{{ (services.find(o => o.id === billing_info.service_id) || {}).name || 'Service' }}</td>
                                                <td>{{'Day-'+ billing_info.day_number }}</td>
                                                <td style="text-align:right">
                                                    {{ Number(billing_info.service_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                                </td>
                                            </tr>

                                            <!-- Doctor visit fee -->
                                            <tr v-if="billing_info.visit_amount && Number(billing_info.visit_amount) > 0">
                                                <td>{{ billing_info.service_id ? 2 : 1 }}</td>
                                                <td>Doctor Visit Fee</td>
                                                <td></td>
                                                <td style="text-align:right">
                                                    {{ Number(billing_info.visit_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!--End Table-->
                                </div>

                                <!-- Payment Info and Others-->
                                <div class="corporate-payment-info">
                                    <div class="row">
                                        <div class="col-md-7 col-xs-7">
                                            
                                        </div>
                                        <div class="col-md-5 col-xs-5">
                                            <table class="payment-info" style="width: 100%; text-align: right;">
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Total Amount</td>
                                                    <td>{{ Number(billing_info.total_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Discount </td>
                                                    <td>
                                                        {{ Number(billing_info.discount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}}
                                                    </td>
                                                </tr>
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Payable Amount</td>
                                                    <td>{{ Number(billing_info.payable_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</td>
                                                </tr>                                                       
                                                <tr>
                                                    <td>Received Amount </td>
                                                    <td>
                                                        {{ Number(billing_info.paid_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
                                                    </td>
                                                </tr>                                                
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Due Amount </td>
                                                    <td>
                                                        {{ Number(billing_info.payable_amount - billing_info.paid_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>                                            
                                </div>

                                <div class="fixed-div">
                                    <div class="status-signatures">
                                        <div class="row">
                                            <div class="col-md-8 col-xs-8">
                                                <div class="status-info">
                                                    <h3 v-if="(billing_info.payable_amount) == billing_info.paid_amount">
                                                        <span style="">PAID</span>
                                                    </h3> 
                                                    <h3 v-else>
                                                        <span>DUE</span>
                                                    </h3> 
                                                    <span style="font-size: 11px;">Printed on {{ new Date().toLocaleDateString() }} {{ new Date().toLocaleTimeString() }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-xs-4">
                                                <div class="signature-info">
                                                    <h4>{{ billing_info.created_users.name }}</h4>
                                                    <span>(Signature)</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="legal-info">
                                        <h6>
                                            সকল তথ্য ও সিরিয়াল এর জন্য হটলাইনঃ {{ this.invHeadPhone }}
                                        </h6>
                                    </div>
                                </div>

                            </div>
                            <!--End InvoiceBot-->
                        </div>
                        <!--End Invoice-->
                    </div>
                    <div class="modal-footer">
                        <div class="col-md-12">
                            <div class="row button-list pt-2">
                            <div class="col-md-4" style="padding: 0 5px">
                                <div class="d-grid">
                                <button
                                    type="button"
                                    class="btn btn-sm btn-success"
                                    @click="printInvoice('billing-invoice')"
                                >
                                    Print
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal> 


        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import BarcodeGenerator from "@/components/BarcodeGenerator.vue";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted, render } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Appointments',
    components: {
        Modal,
        BarcodeGenerator,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            doctorAddModalActive:false,
            invoiceModalActive:false,            
            invoicePreviewModalActive:false,            
            errors: {},
            imagePreview: '',
            btn:'SUBMIT',
            renderOptionComponent: true,
            renderBarcodeComponent: true,
            items: [],
            gender_options: [{label:'Male', value:'male'}, {label:'Female', value:'female'}],
            doctors: [],
            doctor_options: [],
            services: [],  
            service_options: [],
            service_days_items: [],
            service_days_options: [],
            selected_service_stock_item: null,
            service_stock_items: [],
            stock_item_options: [],
            billing_info: '',  
            patients: [],
            patient_options: [],    
            companies: [],
            departments: [],
            search_patient_id: null,
            patient_contracts: [],
            contract_options: [],
            form: new Form({
                id: '',
                bill_no: '',
                bill_date: '',
                service_id: '',
                day_number: '', 
                service_day_id: '',
                patient_name: '',
                patient_age: '',
                patient_gender: '',
                patient_phone: '',
                doctor_id: '',
                service_day_items: [],
                vat_tax: 0,
                contract_id: null,
                contract_amount: 0,
                contract_paid_amount: 0,
                contract_due_amount: 0,
                visit_amount: 0,
                service_amount: 0,
                discount: 0,
                received_amount: 0,
                status: 1,
            }),
            age: {
                years: '',
                months: '',
                days: '',
            },
            dform: new Form({
                id: '',
                doctor_code: '', 
                company_id: 0, 
                department_id: "", 
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                designation: '',
                qualification: '',
                specialist: '',
                dob: '',
                blood_group: '',
                gender: 'male',
                status: 1,
                create_user: 0,
                password: '',
                password_confirmation: '',
                commission_percentage: '',
                description: '',
                dimage: '',
                doctor_commission_account: '',
            }),
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },

        };
    },

    created() { 
        this.fetchDentalBIllingCreateData();
        this.fetchCompany();
        this.fetchDepartments();
    },

    methods: { 
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;
            this.renderBarcodeComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
                this.renderBarcodeComponent = true;

            });
        },

        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
        },

        // For Doctor Add Modal
        toggleDoctorModal: function() {
            this.doctorAddModalActive = !this.doctorAddModalActive;   
            if(!this.doctorAddModalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
        },

        doctorAddModal: function() {  
            this.forceRerender();
            this.doctorAddModalActive = !this.doctorAddModalActive;
        },
        
        // Ledger Account Name Setup
        ledgerAccountNameSetup: function(value) {
            if(value != '') {
                this.dform.doctor_commission_account = 'Provision for '+value;
            }else{
                this.dform.doctor_commission_account = '';
            }
        },

        submitDoctorForm: function(e) {  
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();              
            // formData.append('doctor_code', this.dform.doctor_code);
            formData.append('company_id', this.dform.company_id);
            formData.append('department_id', this.dform.department_id);
            formData.append('first_name', this.dform.first_name);
            formData.append('last_name', this.dform.last_name);
            formData.append('email', this.dform.email);
            formData.append('phone', this.dform.phone);
            formData.append('designation', this.dform.designation);
            formData.append('qualification', this.dform.qualification);
            formData.append('specialist', this.dform.specialist);
            formData.append('dob', this.dform.dob);
            formData.append('blood_group', this.dform.blood_group);
            formData.append('gender', this.dform.gender);
            formData.append('status', this.dform.status);
            formData.append('create_user', this.dform.create_user);
            formData.append('password', this.dform.password);
            formData.append('password_confirmation', this.dform.password_confirmation);
            formData.append('commission_percentage', this.dform.commission_percentage);
            formData.append('description', this.dform.description);
            formData.append('doctor_commission_account', this.dform.doctor_commission_account);

            this.dform.dimage ? formData.append('dimage', this.dform.dimage, this.dform.dimage.name) : '';
            var postEvent = axios.post(this.apiUrl+'/hm/doctors', formData, this.headers);          

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleDoctorModal();
                    this.dform.reset();
                    this.doctor_options.push({label:res.data.data.first_name + ' ' + res.data.data.last_name, value:res.data.data.id});
                    this.form.reference_person_id = res.data.data.id;
                    this.form.reference_person_name = res.data.data.first_name + ' ' + res.data.data.last_name;
                    
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                } 
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        onImageChange(e) {
            this.form.dimage = e.target.files[0]
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;  
            
            this.createImage(files[0]);

        },

        createImage(file) {
            let reader = new FileReader();
            let vm = this;
            reader.onload = (e) => { 
                vm.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        // End Doctor Add Modal
         
        invoiceModal: function() {  
            this.forceRerender();
            this.invoiceModalActive = !this.invoiceModalActive;
        },

        invoicePreviewModal: function() {
            this.forceRerender();
            this.invoicePreviewModalActive = !this.invoicePreviewModalActive;
        },

        printContent(document_id) { 
            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    this.baseUrlPrintCSS+'/assets/css/billing_invoice.css'
                ],
            };
            this.$htmlToPaper(document_id, options);
        },

        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }); 
        }, 
        
        fetchDepartments() { 
            axios.get(this.apiUrl+'/hm/departments', this.headerjson)
            .then((res) => {
                // this.departments = res.data.data; 
                this.departments = [{label: "Select Department", value: ""}];
                res.data.data.map((item) => {
                    this.departments.push({label:item.name, value:item.id});
                });
            }) 
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
        }, 

        fetchDentalBIllingCreateData() {
            axios.get(this.apiUrl+'/hm/dental_billings/create', this.headerjson)
            .then((res) => {
                let data = res.data.data;
                this.form.bill_no = data.bill_no;
                this.form.bill_date = data.bill_date;
                this.services = data.service_items;
                this.service_options = data.service_items.map((item) => {
                    return {label:item.name, value:item.id}
                }); 
                this.doctors = data.doctors;
                this.doctor_options = data.doctors.map((item) => {
                    return {label:item.first_name + ' ' + item.last_name, value:item.id}
                });

                this.service_stock_items = data.service_stock_items;
                this.stock_item_options = data.service_stock_items.map((item) => {
                    return {label:item.products.product_name, value:item.id}
                });
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
            });
        },

        loadServiceDaysConfig(value) {
            let service_id = value;
            this.form.day_number = '';
            this.form.service_day_id = '';
            this.form.service_day_items = [];
            this.service_days_options = [];

            console.log("service_id==", service_id);
            if(service_id != '') {
                axios.get(this.apiUrl+'/hm/dental_service_configurations/'+service_id, this.headerjson)
                .then((res) => {
                    console.log("dsfhsdkjjl==", res.data);
                    let data = res.data;
                    this.service_days_items = data;
                    this.service_days_options = data.map((item) => {
                        return {label:item.day_title, value:item.day_number}
                    });
                })
                .catch((err) => { 
                    this.$toast.error(err.response.data.message);
                });
            }
        },

        applyServiceDaysConfig(value) {
            let day_number = value;
            let service_id = this.form.service_id;
            let selected_day = this.service_days_items.find(day => day.service_id == service_id && day.day_number == day_number);
            let service_day_id = selected_day ? selected_day.id : '';
            this.form.service_day_id = service_day_id;
            this.form.service_day_items = [];
            if(service_day_id != '') {
                axios.get(this.apiUrl+'/hm/getDayConfigurationWithStockDetails/'+service_id+'/'+day_number, this.headerjson)
                .then((res) => {
                    let data = res.data.data;
                    this.form.service_day_items = data.config_items;
                })
                .catch((err) => { 
                    this.$toast.error(err.response.data.message);
                });
            }
        },

        addServiceDayItems() {
            let existingItems = this.form.service_day_items;
            let selectedStockItem = this.service_stock_items.find(item => item.id === this.selected_service_stock_item);
            let isAlreadyAdded = existingItems.some(item => item.stock_id == selectedStockItem.id && item.product_id == selectedStockItem.product_id);
            if (isAlreadyAdded) {
                this.$toast.error('This service item is already added!');
                return;
            }
            let newItems = {
                stock_id: selectedStockItem.id,
                product_id: selectedStockItem.product_id,
                product_name: selectedStockItem.products.product_name,
                cost_per_unit: selectedStockItem.cost_per_unit,
                per_service_cost: selectedStockItem.per_service_cost,
                per_service_qty: selectedStockItem.per_service_qty,
                service_qty: 1,
                consume_qty: 1 * selectedStockItem.per_service_qty,
            };
            this.form.service_day_items = existingItems.concat(newItems);
        },  

        removeServiceDayItems(index) {
            this.form.service_day_items.splice(index, 1);
        },

        getPatientByPhone(event) {
            let service_id = this.form.service_id;
            let phone = event.target.value;
            if ((typeof event !== 'undefined' && (event.keyCode === 13) ) || false) {
                this.search_patient_id = null;
                this.form.patient_name = '';
                this.form.patient_age = '';
                this.form.patient_gender = '';
                this.patients = [];
                this.patient_options = [];
            }
            
            if (phone.length < 11 && 
                (
                    (typeof event !== 'undefined' && (event.keyCode === 13) ) ||
                    // fallback: if event is not available, still allow for legacy behavior
                    false
                )
            ) {
                this.$toast.error('Please enter valid phone number!');
                return;
            }

            if(!service_id) {
                this.$toast.error('Please select service first!');
                this.form.patient_phone = '';
                return;
            }
            // Only proceed if phone is 11 digits and last key pressed was 'g' or 'G'
            if (phone.length === 11 &&
                (
                    (typeof event !== 'undefined' && (event.keyCode === 13) ) ||
                    // fallback: if event is not available, still allow for legacy behavior
                    false
                )
            ) {
                axios.get(this.apiUrl+'/hm/dental_billings/get-patient-by-phone?phone='+phone+'&service_id='+service_id, this.headerjson)
                .then((res) => {
                    this.search_patient_id = null;
                    this.form.patient_name = '';
                    this.form.patient_age = '';
                    this.form.patient_gender = '';
                    this.patients = [];
                    this.patient_options = [];
                    let data = res.data.data;
                    if(data.length == 1) {
                        this.form.patient_name = data[0].name;
                        this.form.patient_age = data[0].age;
                        this.form.patient_gender = data[0].gender;
                        this.search_patient_id = data[0].id;

                        console.log("data[0].dental_contracts==", data[0]);
                        if(data[0].dental_contracts && data[0].dental_contracts.length > 0) {
                            this.patient_contracts = data[0].dental_contracts || [];
                            this.contract_options = data[0].dental_contracts.map((item) => {
                                return {label:'Contract-'+item.contract_code, value:item.id}
                            });
                        }
                    }else {
                        this.patients = data;
                        this.patient_options = data.map((item) => {
                            return {label:item.name, value:item.id}
                        });

                        setTimeout(() => {
                            // wait for DOM update AFTER options assigned
                            this.$nextTick(() => {
                                if (this.$refs.patientMultiselect) {
                                    this.$refs.patientMultiselect.activate(); // open & focus
                                }else {
                                    console.warn('patient multiselect ref not ready yet');
                                }
                            });
                        }, 1000);

                    }
                })
                .catch((err) => { 
                    this.$toast.error(err.response.data.message);
                });
            }
        },

        changePatient(selectedValue) {
            this.patient_contracts = [];
            this.contract_options = [];
            this.form.contract_id = null;
            const selectedOption = this.patient_options.find(option => option.value === selectedValue);
            if (selectedOption) {
                const patient = this.patients.find(p => p.id === selectedValue);
                if (patient) {
                    this.form.patient_name = patient.name;
                    this.form.patient_age = patient.age;
                    this.form.patient_gender = patient.gender;
                    this.search_patient_id = patient.id;
                    this.patient_contracts = patient.dental_contracts || [];
                    this.contract_options = patient.dental_contracts.map((item) => {
                        return {label:'Contract-'+item.contract_code, value:item.id}
                    });
                }
            }else{
                this.form.patient_name = '';
                this.form.patient_age = '';
                this.form.patient_gender = '';
                this.search_patient_id = null;
            }
        },

        onContractChange(selectedValue) {
            const selectedContract = this.patient_contracts.find(contract => contract.id === selectedValue);
            if (selectedContract) {
                this.form.contract_amount = selectedContract.contract_amount;
                this.form.contract_paid_amount = selectedContract.paid_amount;
                this.form.contract_due_amount = selectedContract.due_amount;
            } else {
                this.form.contract_amount = 0;
                this.form.contract_paid_amount = 0;
                this.form.contract_due_amount = 0;
            }
        },

        updateConsumeQty(index) {
            // Just to trigger reactivity
            let item = this.form.service_day_items[index];
            let consume_qty = parseFloat(item.service_qty) * parseFloat(item.per_service_qty);
            item.consume_qty = consume_qty;

            console.log("item==", item);
        },

        parseAge(ageString) {
            if(!ageString) {
                this.age.years = '';
                this.age.months = '';
                this.age.days = '';
                return;
            }
            const match = ageString.match(/(\d+)y\s*(\d+)m\s*(\d+)d/)
            if (match) {
                this.age.years  = Number(match[1])
                this.age.months = Number(match[2])
                this.age.days   = Number(match[3])
            }else{
                if(ageString) {
                    this.age.years = ageString;
                    this.updateAge();
                }
            }
        },

        validateAge(field) {
            if(field === 'years' && this.age.years < 0) {
                this.age.years = 0;
            }
            if(field === 'months') {
                if(this.age.months < 0) {
                    this.age.months = 0;
                } else if(this.age.months > 11) {
                    this.age.months = 11;
                }
            }
            if(field === 'days') {
                if(this.age.days < 0) {
                    this.age.days = 0;
                } else if(this.age.days > 29) {
                    this.age.days = 29;
                }
            }
        },

        updateAge() {
            let y = this.age.years || 0
            let m = this.age.months || 0
            let d = this.age.days || 0

            this.form.patient_age = `${y}y ${m}m ${d}d`
        },
        
        show: function(item) {     
            axios.get(this.apiUrl+'/hm/dental_billings/'+item.id, this.headers).then(res => {
                if(res.status == 200){  
                    this.customer = res.data.data
                    this.showModal = !this.showModal;  
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => {  
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            }) 
        },

        edit: function(item) { 
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            let department_doctors = this.doctors.filter((doctor, index) => {
                    return doctor.department_id == item.department_id;
            });

            if(department_doctors.length > 0) {
                this.doctor_options = department_doctors.map((item) => { 
                    return {label:item.name, value:item.id};
                });
            }

            this.form.fill(item);  
        },

        submitForm: function(e) {  

            if(this.form.received_amount < this.netAmountCalculate || 
            this.form.received_amount == 0 || 
            this.form.received_amount == '' ||
            this.form.received_amount > this.netAmountCalculate
        ) {
                this.$toast.error('Received amount must be equal payable amount!');
                return;
            }

            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();    
            formData.append('bill_no', this.form.bill_no);
            formData.append('bill_date', this.form.bill_date);
            formData.append('service_id', this.form.service_id);
            formData.append('day_number', this.form.day_number);
            formData.append('service_day_id', this.form.service_day_id);
            formData.append('patient_id', this.search_patient_id);
            formData.append('patient_name', this.form.patient_name);
            formData.append('patient_age', this.form.patient_age);
            formData.append('patient_gender', this.form.patient_gender);
            formData.append('patient_phone', this.form.patient_phone);
            formData.append('doctor_id', this.form.doctor_id);
            formData.append('service_day_items', JSON.stringify(this.form.service_day_items));
            formData.append('contract_amount', this.form.contract_amount);
            formData.append('visit_amount', this.form.visit_amount);
            formData.append('service_amount', this.form.service_amount);
            formData.append('total_amount', this.totalCalculateAmount);      
            formData.append('discount', this.form.discount);       
            formData.append('payable_amount', this.netAmountCalculate);     
            formData.append('received_amount', this.form.received_amount);
            formData.append('status', this.form.status);

            if(this.editMode) {
                formData.append('_method', 'put');           
                formData.append('id', this.form.id);
                var postEvent = axios.post(this.apiUrl+'/hm/dental_billings/'+this.form.id, formData, this.headers);
            } else{  
                var postEvent = axios.post(this.apiUrl+'/hm/dental_billings', formData, this.headers);
            }           

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                        this.billing_info = res.data.data;
                        this.form.reset();
                        this.search_patient_id = null;
                        this.patients = [];
                        this.patient_options = [];
                        this.forceRerender();
                        this.invoiceModal();
                        this.fetchDentalBIllingCreateData();
                        this.$toast.success(res.data.message); 

                        setTimeout(() => {
                            this.printContent("billing-invoice");
                        }, 3000);
                }else{
                    this.$toast.error(res.data.message);
                } 
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this bill!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/hm/diagnosis_billings/'+item.id,this.headerjson)
                    .then(res => {
                        if(res.status == 200){  
                            this.fetchDiagnosisBIllingCreateData();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        printInvoice: function (print_id) {   
            this.printContent(print_id);
            // this.invoiceModal();
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        
        netAmountCalculate: function () {
            let result = 0;
            result = parseFloat(parseFloat(this.form.visit_amount) + parseFloat(this.form.service_amount)) - parseFloat(this.form.discount);
            return parseFloat(result).toFixed(2);
        },
        totalCalculateAmount: function () {
            let result = 0;
            result = parseFloat(this.form.visit_amount) + parseFloat(this.form.service_amount);
            return parseFloat(result).toFixed(2);
        },

        totalServiceItemsValue: function () {
            let total = 0;
            this.form.service_day_items.forEach(item => {
                total += parseFloat(item.per_service_cost) * parseFloat(item.service_qty);
            });
            return parseFloat(total).toFixed(2);
        },

    }
}
</script>
<style scoped>
    .modal-content.scrollbar-width-thin {
        border: none !important;
    }

    label {
        display: inline-block;
        margin: 0px 0px 4px 2px;
        float: left;
    }

    .invalid-feedback {
        display: block;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #dc3545;
        text-align: left;
    }

    #newBilling hr {
        margin-top: 0px !important;
    }

    .wpr_general_sign_title {
        width: 100%;
        display: block;
        padding: 8px 20px;
        background-color: #313A46;
        display: block;
        color: #fff;
        font-weight: 700;
        font-size: 18px;
    }

    
    /** Autocomplete */
    .autocomplete {
        position: relative;
    }

    ul.autocomplete-results {
        width: 100% !important;
        margin-top: 1px !important;
        position: absolute;
        left: 0;
        z-index: 999;
    }
    .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid #eeeeee;
        /* height: 120px; */
        overflow: auto;
        width: 100%;
    }

    .autocomplete-results li{
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;
    /* background: red; */
    }

    .autocomplete-results li.is-active,
    .autocomplete-results li:hover {
        background-color: #4AAE9B;
        color: white;
    }
    .autocomplete-results li:first-child {
        font-weight: 600;
        border-bottom: 1px solid #282828;
        margin-bottom: 3px;
    }
    .autocomplete-results li:first-child:hover {
        background-color: inherit;
        color: inherit;
    }

    .is-active {
        background-color: #dedede;
    }

    ul.discount_items {
        list-style: none;
        padding: 0;
    }

    ul.discount_items li {
        display: block;
        margin-right: 5px;
        clear: both;
    }

    ul.discount_items li .discount_fields .item_field input{
        margin-bottom: 5px;
    }

    /** For Invoice modal css */
    .modal-content.scrollbar-width-thin.invoice-modal {
        width: 100%;
        display: block;
        margin: auto;
    }

    .invoice-billing {
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }

    .invoice-billing #top h2{
        font-size: 18px;
    }

    .invoice-billing #top h5{
        font-size: 14px;
    }

    .invoice-billing #top p{
        font-size: 14px;
    }

    .invoice-billing #mid {
        margin-bottom: 10px;
    }

    #mid .info {
        border: 1px solid #282828;
        padding: 0 10px 5px 10px;
        border-radius: 10px;
        margin-bottom: 10px;
    }

    #mid .info table {
        width: 100%;
    }

    #mid .info table tr td{
        font-size: 14px;
    }

    #mid .info table tr td#pname {
        font-weight: 550;
        font-size: 15px;
        text-transform: uppercase;
    }

    #bot .items-info table thead {
        border: 1px solid #282828;
        font-size: 14px;
    }

    #bot .items-info table thead td{
        padding: 5px 10px;
    }

    #bot .items-info table tbody tr{
        border-bottom: 1px solid #e0e0e0;
    }
    #bot .items-info table tbody td{
        padding: 3px 10px;
        font-size: 14px;
    }

    .corporate-payment-info {
        margin-top: 10px;
    }

    .corporate-info p{
        font-size: 14px;
    }

    .payment-info {
        width: 100%;
        border: none;
    }

    .payment-info tr {
        border-bottom: 0 !important;
    }

    .payment-info tr td{
        padding: 3px 10px;
        font-size: 14px;
        border: 0 !important;
        border-top: 0 !important;
        border-bottom: 0 !important;
    }

    .status-signatures {
        margin-top: 10px;
    }

    .status-info h3 {
        font-size: 18px;
    }

    .status-info h3 span {
        padding: 5px; 
        font-size: 22px;
        border: 1px solid #282828; 
        border-radius: 0px;
    }

    .status-info span {
        font-size: 11px;
    }

    .signature-info {
        text-align: center;
    }
    .signature-info h4 {
        text-align: center;
        font-size: 16px;
        border-bottom: 2px solid #e0e0e0;
        margin-bottom: 5px;
        padding-bottom: 2px;
    }

    .signature-info span {
        font-size: 14px;
        text-align: center;
    }

    .room-info {
        margin-top: 10px;
    }

    .room-info p {
        font-size: 13px;
    }

    .room-info p span {
        padding: 5px 10px;
        font-size: 13px;
        margin-right: 5px;
        border: 1px solid #282828;
        border-radius: 0;
    }

    .legal-info {
        margin-top: 10px;
    }

    .legal-info h6 {
        text-align: center;
        font-size: 13px;
        margin-top: 0;
        margin-bottom: 7px;
    }


    
    .input-group.input-group-merge {
        height: 38px;
    }
    .input-group-text {
        height: 40px;
    }

</style>